import React, { useEffect, useRef } from 'react';

/**
 * AdSense bloc réutilisable.
 *
 * Props :
 * - slot (string, obligatoire) : l'ID du bloc AdSense (data-ad-slot).
 * - format (string) : "auto" par défaut.
 * - responsive (bool) : true par défaut.
 * - style / className : pour ajuster le conteneur.
 */
export default function Ads({
  slot,
  format = 'auto',
  responsive = true,
  style = {},
  className = '',
}) {
  const adRef = useRef(null);
  const clientId = process.env.REACT_APP_ADSENSE_CLIENT || 'ca-pub-9974764507775738';

  useEffect(() => {
    const adEl = adRef.current;
    if (!adEl || !slot) return;

    // S'assurer que le script global n'est injecté qu'une seule fois.
    const existingScript = document.querySelector('script#adsbygoogle-init');
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'adsbygoogle-init';
      script.async = true;
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${clientId}`;
      script.crossOrigin = 'anonymous';
      document.head.appendChild(script);
    }

    // Éviter de pousser deux fois le même <ins> (mode Strict monte/démonte).
    if (adEl.getAttribute('data-adsbygoogle-status') === 'done') return;

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      // Garder silencieux en prod mais log en dev pour debug.
      if (process.env.NODE_ENV === 'development') {
        console.error('AdSense push error', err);
      }
    }
  }, [slot, clientId]);

  return (
    <ins
      ref={adRef}
      className={`adsbygoogle ${className}`.trim()}
      style={{ display: 'block', ...style }}
      data-ad-client={clientId}
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive ? 'true' : 'false'}
    />
  );
}
